(() => {
  const rootSelector = '.ushopaid-bundle-as-product-wrapper';
  const menuSelector = '.dropdown-menu';
  const frame = () => new Promise((resolve) => requestAnimationFrame(resolve));
  let scheduled = false;
  let scanning = false;
  let bundleHelper = null;

  const getMenu = (item) => item.querySelector(menuSelector);

  const openMenu = async (item) => {
    const trigger = item.querySelector('.dropdown-trigger');
    if (!trigger) return null;
    if (!getMenu(item)) trigger.click();
    for (let attempt = 0; attempt < 4 && !getMenu(item); attempt += 1) await frame();
    return getMenu(item);
  };

  const closeMenu = (item) => {
    if (getMenu(item)) item.querySelector('.dropdown-trigger')?.click();
  };

  const getGroups = (menu) => [...menu.querySelectorAll('.select-wrapper')].map((group, index) => ({
    name: group.querySelector('.option-name')?.textContent.trim() || `Option ${index + 1}`,
    values: [...group.querySelectorAll('.variant-item')].map((option) => ({
      value: option.getAttribute('title') || option.textContent.trim(),
      selected: option.classList.contains('selected'),
      disabled: option.classList.contains('item-disabled'),
    })),
  })).filter((group) => group.values.length);

  const selectChoice = async (button) => {
    const item = button.closest('.ush-product-item');
    if (!item || button.disabled || item.dataset.mpBundleSelecting === 'true') return;
    item.dataset.mpBundleSelecting = 'true';
    try {
      const menu = await openMenu(item);
      const group = [...(menu?.querySelectorAll('.select-wrapper') || [])][Number(button.dataset.group)];
      const option = [...(group?.querySelectorAll('.variant-item') || [])].find((candidate) =>
        (candidate.getAttribute('title') || candidate.textContent.trim()) === button.dataset.value
      );
      if (!option || option.classList.contains('item-disabled')) return;
      option.click();
      const choices = button.closest('.mp-bundle-options__choices');
      choices?.querySelectorAll('.mp-bundle-options__choice').forEach((choice) => {
        choice.setAttribute('aria-pressed', String(choice === button));
      });
      const selectedValue = button.closest('.mp-bundle-options__group')?.querySelector('.mp-bundle-options__selected');
      if (selectedValue) selectedValue.textContent = button.dataset.value;
      await frame();
    } finally {
      closeMenu(item);
      delete item.dataset.mpBundleSelecting;
      schedule();
    }
  };

  const enhance = async (item) => {
    const dropdown = item.querySelector('.dropdown-container');
    if (!dropdown || item.querySelector('.mp-bundle-options') || item.dataset.mpBundleProbing === 'true') return;
    item.dataset.mpBundleProbing = 'true';
    try {
      const menu = await openMenu(item);
      if (!menu) return;
      const groups = getGroups(menu);
      if (!groups.length) return;

      const options = document.createElement('div');
      options.className = 'mp-bundle-options';
      groups.forEach((group, index) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'mp-bundle-options__group';
        const legend = document.createElement('legend');
        const selectedValue = document.createElement('span');
        selectedValue.className = 'mp-bundle-options__selected';
        selectedValue.textContent = group.values.find(({ selected }) => selected)?.value || '';
        legend.append(group.name, group.name.endsWith('?') ? ' ' : ': ', selectedValue);
        const choices = document.createElement('div');
        choices.className = 'mp-bundle-options__choices';
        group.values.forEach(({ value, selected, disabled }) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mp-bundle-options__choice';
          button.textContent = value;
          button.dataset.group = String(index);
          button.dataset.value = value;
          button.disabled = disabled;
          button.setAttribute('aria-pressed', String(selected));
          button.addEventListener('click', () => selectChoice(button));
          choices.appendChild(button);
        });
        fieldset.append(legend, choices);
        options.appendChild(fieldset);
      });
      dropdown.before(options);
      dropdown.classList.add('mp-bundle-hidden-select');
      dropdown.setAttribute('aria-hidden', 'true');
    } finally {
      closeMenu(item);
      delete item.dataset.mpBundleProbing;
    }
  };

  const scan = async () => {
    if (scanning) return;
    scanning = true;
    try {
      for (const item of document.querySelectorAll(`${rootSelector} .ush-product-item`)) {
        await enhance(item);
      }
      bundleHelper = document.querySelector('[data-bundle-harness-helper]') || bundleHelper;
      const harnessItem = [...document.querySelectorAll(`${rootSelector} .ush-product-item`)].find((item) =>
        /harness/i.test(item.querySelector('.header-title')?.textContent || '')
      );
      if (bundleHelper && harnessItem && !harnessItem.contains(bundleHelper)) {
        const placement = harnessItem.querySelector('.mp-bundle-options, .dropdown-container');
        if (placement) placement.before(bundleHelper);
        else harnessItem.querySelector('.content-top')?.after(bundleHelper);
      }
    } finally {
      scanning = false;
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  };

  const start = () => {
    const host = document.querySelector('product-info') || document.body;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    schedule();
    document.addEventListener('shopify:section:load', schedule);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
